import { render, staticRenderFns } from "./DkttHistoryInfo.vue?vue&type=template&id=9de3f384&scoped=true"
import script from "./DkttHistoryInfo.vue?vue&type=script&lang=js"
export * from "./DkttHistoryInfo.vue?vue&type=script&lang=js"
import style0 from "./DkttHistoryInfo.vue?vue&type=style&index=0&id=9de3f384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de3f384",
  null
  
)

export default component.exports